export const connectionLevels = [
  'Not yet',
  'Aware of me',
  'Met once',
  'Occasionally engaged',
  'Currently engaged'
];
